__turbopack_context__.v({
  "lineClamp": "lineClamp-module__MNuygW__lineClamp",
});
